var map = {
	"./29/BiddersRewards.json": 12140,
	"./30/BiddersRewards.json": 73702,
	"./33/BiddersRewards.json": 58421,
	"./34/BiddersRewards.json": 45498,
	"./35/BiddersRewards.json": 31775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38542;